import { render, staticRenderFns } from "./ImageTextEdit.vue?vue&type=template&id=4a760f86&scoped=true"
import script from "./ImageTextEdit.vue?vue&type=script&lang=js"
export * from "./ImageTextEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a760f86",
  null
  
)

export default component.exports